import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=8ab8a5a4&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=8ab8a5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab8a5a4",
  null
  
)

export default component.exports